window.allAddedCartProcess = function (response) {
    //extcart_merge.js에 포함된 함수
    window.proceed_after_adding_product_to_extcart(response);
}

$(document).ready(function () {
    require(['jquery', 'spinner', 'api-request'], function ($, spinner, apiRequest) {

// 위젯 장바구니 한개 담기 버튼 타이머
        var replace_widget_cart_button_timer = null;
// 위젯 장바구니 여러개 담기 버튼 타이머
        var replace_widget_bundle_cart_button_timer = null;

        function addCart(variant_ids) {
            var variant_id = variant_ids.pop();
            spinner.show({
                img      : "//ws.cconma.com/Images/Mobile/Ccapp/Icon/loading_gray.gif",
                size     : 46,
                bg       : "rgba(255, 255, 255, 0.7)",
                box_bg   : "rgba(200,200,200,0.8)",
                font_size: 18,
                color    : "#555555"
            }, '장바구니 담는중')
                .then(function () {
                    return apiRequest.post("//www.cconmausa.com/apps/ext9api/jsapi", {
                        action     : "add_to_extcart",
                        cart_token : _cart_token,
                        customer_id: _customer_id,
                        variant_id : variant_id,
                        quantity   : 1,//self.cart.quantity
                    });
                })

                .then(function (response) {
                    if (variant_ids.length === 0)
                    {
                        window.allAddedCartProcess(response);
                    }
                    else
                    {
                        addCart(variant_ids);
                    }

                })
                .then(spinner.hide);
        }


        /*
        personalized recommendation 앱 장바구니 버튼 이벤트 교체
        - 꽃마USA 외부 장바구니에 상품을 담기 위해 장바구니 버튼 클릭 이벤트를 교체해야함
        - 이벤트 교체 매커니즘
        1. 100ms 단위로 앱 위젯이 렌더링 됐는지 체크
        - 위젯이 렌더링 되면 장바구니 버튼 element가 생성됨
        2. 위젯의 모든 장바구니 버튼의 이벤트를 제거
        - javascript로 등록된 이벤트 리스너를 제거하려면 element를 새로 렌더링 해야함
        $(this)[0].outerHTML = $(this)[0].outerHTML
        3. 위젯의 모든 장바구니 버튼에 꽃마USA 장바구니 담기 이벤트 bind
        - button, select, checkbox에 해당하는 이벤트 bind
        - 간혹 앱이 이벤트를 늦게 등록되는 경우가 있기 때문에 e.stopImmediatePropagation();를 선언하여 이후 등록된 이벤트가 무시되도록 함.
        */

        /**
         * 위젯 장바구니 한개 담기 버튼 이벤트 교체
         */
        function replaceWidgetCartButtonAndSelectEvent() {
            if ($(".rktheme-addtocart-button, .rktheme-addtocart-select").length > 0)
            {
                clearInterval(replace_widget_cart_button_timer);
                setTimeout(function () {
                    $(".rktheme-addtocart-button, .rktheme-addtocart-select").each(function () {
                        $(this)[0].outerHTML = $(this)[0].outerHTML;
                    });

                    $(".rktheme-addtocart-button").click(function (e) {
                        e.stopImmediatePropagation();
                        var variant_id = $(this).data("rk-variant-id");
                        addCart([variant_id]);
                    });

                    $(".rktheme-addtocart-select").change(function (e) {
                        e.stopImmediatePropagation();
                        var variant_id = $(this).val();
                        if (!variant_id)
                        {
                            return;
                        }
                        addCart([variant_id]);
                    });
                }, 100);
            }
        }

        /**
         * 위젯 장바구니 여러개 담기 버튼 이벤트 교체
         */
        function replaceWidgetBundleCartButtonsEvent() {
            if ($(".rktheme-bundle-add-to-cart").length > 0)
            {
                clearInterval(replace_widget_bundle_cart_button_timer);

                setTimeout(function () {
                    $(".rktheme-bundle-add-to-cart").each(function () {
                        $(this)[0].outerHTML = $(this)[0].outerHTML;
                    });

                    $(".rktheme-bundle-add-to-cart").click(function (e) {
                        e.stopImmediatePropagation();
                        var $container = $(this).parents(".rktheme-bundle-container");
                        var variant_ids = [];
                        $container.find(".rktheme-bundle-product").each(function () {
                            if ($(this).find(".rktheme-bundle-product-checkbox").is(":checked"))
                            {
                                var variant_id = $(this).data('rk-variant-id');
                                variant_ids.push(variant_id);
                            }
                        });
                        addCart(variant_ids);
                    });

                    $(".rktheme-bundle-product-checkbox").click(function (e) {
                        e.stopImmediatePropagation();
                        setTimeout(replaceWidgetBundleCartButtonsEvent, 10);
                    });
                    $(".rktheme-bundle-product-variant-select").change(function (e) {
                        e.stopImmediatePropagation();
                        setTimeout(replaceWidgetBundleCartButtonsEvent, 10);
                    });
                    $(".rktheme-bundle-product-checkbox").each(function () {
                        $(this).after("<label class='custom-checkbox'></label>");
                    });
                    $(".custom-checkbox").click(function () {
                        var $checkbox = $(this).siblings(".rktheme-bundle-product-checkbox");
                        $checkbox.click();
                    });
                }, 100);
            }
        }

        replace_widget_cart_button_timer = setInterval(replaceWidgetCartButtonAndSelectEvent, 100);
        replace_widget_bundle_cart_button_timer = setInterval(replaceWidgetBundleCartButtonsEvent, 100);

        setTimeout(function () {
            clearInterval(replace_widget_cart_button_timer);
            clearInterval(replace_widget_bundle_cart_button_timer);
        }, 3000);
    });
});